/**
 * network — وضعیت آنلاین/آفلاین مرورگر به‌صورت واکنش‌گرا (reactive).
 *
 * از navigator.onLine و رویدادهای online/offline استفاده می‌کند. برای اطمینان
 * بیشتر، هنگام رخداد online یک بررسی سبک هم انجام می‌دهد (navigator.onLine
 * ممکن است دروغ بگوید — فقط یعنی «به شبکه‌ای وصلم»، نه «اینترنت دارم»).
 */

import { reactive } from "vue";

export const networkState = reactive({
    online: typeof navigator !== "undefined" ? navigator.onLine !== false : true,
    // زمانی که آخرین بار آفلاین شد (برای نمایش «X دقیقه پیش» در آینده اگر لازم شد)
    since: null,
});

let started = false;

function setOnline(value) {
    if (networkState.online === value) return;
    networkState.online = value;
    networkState.since = value ? null : Date.now();
}

export function initNetworkWatch() {
    if (started || typeof window === "undefined") return;
    started = true;

    window.addEventListener("offline", () => setOnline(false));
    window.addEventListener("online", () => {
        // navigator.onLine=true تضمینِ اینترنت نیست؛ یک ping کوچک بزن
        recheck();
    });

    // اگر برگه از حالت مخفی برگشت، وضعیت را دوباره بسنج
    document.addEventListener("visibilitychange", () => {
        if (!document.hidden) recheck();
    });
}

/**
 * تلاش برای رسیدن به سرور تا آنلاین‌بودن واقعی تأیید شود.
 * عمداً یک مسیر ناموجود و کش‌نشده صدا زده می‌شود تا سرویس‌ورکر پاسخ کش‌شده
 * برنگرداند: هر پاسخی از سرور (حتی 404) یعنی آنلاین؛ خطای شبکه یعنی آفلاین.
 */
export function recheck() {
    if (typeof fetch !== "function") {
        setOnline(typeof navigator !== "undefined" ? navigator.onLine !== false : true);
        return Promise.resolve(networkState.online);
    }
    return fetch("/__connectivity__?t=" + Date.now(), {
        method: "HEAD",
        cache: "no-store",
    })
        .then(() => {
            setOnline(true);
            return true;
        })
        .catch(() => {
            setOnline(false);
            return false;
        });
}

export default { networkState, initNetworkWatch, recheck };
